import FileUploadField from './file-upload';
export default FileUploadField;
